import { createSelector } from 'reselect';
import fanSelector from './fanSelector';
import isSwidInWhitelist from 'lib/whitelist';

export default createSelector(
    fanSelector,
    ({ id }) => isSwidInWhitelist(id)
);



// WEBPACK FOOTER //
// ./app/common/selectors/whitelistSelector.js